import { css } from 'styled-components';

export const userWrapper = () => css`
  width: 10rem;
`;
